import { render, staticRenderFns } from "./SlipperyRatingView.vue?vue&type=template&id=7471c9c4"
import script from "./SlipperyRatingView.vue?vue&type=script&lang=js"
export * from "./SlipperyRatingView.vue?vue&type=script&lang=js"
import style0 from "./SlipperyRatingView.vue?vue&type=style&index=0&id=7471c9c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports